import {
  Bar as BaseBar,
  Bubble as BaseBubble,
  Chart as BaseChart,
  Doughnut as BaseDoughnut,
  Line as BaseLine,
  Pie as BasePie,
  PolarArea as BasePolarArea,
  Radar as BaseRadar,
  Scatter as BaseScatter,
} from "react-chartjs-2";
import { useResolvedColors } from "./useResolvedColors";

type ChartLikeProps = { data?: unknown; options?: unknown };

const withResolvedColors = <P extends ChartLikeProps,>(Component: (props: P) => JSX.Element | null) => {
  const Themed = (props: P) => {
    const data = useResolvedColors(props.data);
    const options = useResolvedColors(props.options);
    return <Component {...props} data={data} options={options} />;
  };
  Themed.displayName = `Themed(${(Component as { displayName?: string; name?: string }).displayName ?? (Component as { name?: string }).name ?? "Chart"})`;
  return Themed;
};

export const Bar = withResolvedColors(BaseBar as never);
export const Bubble = withResolvedColors(BaseBubble as never);
export const Chart = withResolvedColors(BaseChart as never);
export const Doughnut = withResolvedColors(BaseDoughnut as never);
export const Line = withResolvedColors(BaseLine as never);
export const Pie = withResolvedColors(BasePie as never);
export const PolarArea = withResolvedColors(BasePolarArea as never);
export const Radar = withResolvedColors(BaseRadar as never);
export const Scatter = withResolvedColors(BaseScatter as never);
